import React, { useState } from 'react'
import PropTypes from 'prop-types'
import * as styles from './PageHeader.module.scss'

const PageHeader = ({ title, subtitle }) => {
  return (
    <>
      <div className={styles.header}>
        <div className={styles.bgOverlay} />
        <div className={styles.headerContent}>
          <div className={styles.heading}>
            <h1>
              Atlas <br />
              <span style={{ color: 'var(--primary)' }}>{title}</span>
            </h1>
            <p>{subtitle}</p>
          </div>
        </div>
      </div>
    </>
  )
}

PageHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string
}

export default PageHeader
